import { BACK_ICON_PATH, TOKEN_SYMBOL_ICON_PATH } from '@/consts/imgPath';
import * as ViewModel from '@/core/presenter/viewModel/viewTypes';
import { useCallback } from 'react';

interface IProps {
  title: string;
  settingViewType: ViewModel.SettingViewType;
  onChangeSettingViewType: (viewType: ViewModel.SettingViewType) => void;
  exitViewType?: string;
  onChangeExitViewType?: (type: string) => void;
}

const SettingViewHeader = ({ title, settingViewType, onChangeSettingViewType, exitViewType, onChangeExitViewType }: IProps) => {
  const handleChangeSettingViewType = useCallback(() => {
    if (settingViewType === ViewModel.SettingViewType.PWD_SETTING)
      onChangeSettingViewType(ViewModel.SettingViewType.MAIN);
    if (settingViewType === ViewModel.SettingViewType.CHECK_PWD_SETTING)
      onChangeSettingViewType(ViewModel.SettingViewType.PWD_SETTING);
    if (settingViewType === ViewModel.SettingViewType.EXIT) {
      if (exitViewType === 'check' && onChangeExitViewType) {
        onChangeExitViewType('exit');
      } else {
        onChangeSettingViewType(ViewModel.SettingViewType.MAIN);
      }
    }
    if (settingViewType === ViewModel.SettingViewType.MANAGE_WALLET_BALANCE)
      onChangeSettingViewType(ViewModel.SettingViewType.MAIN);
  }, [onChangeSettingViewType, settingViewType, exitViewType, onChangeExitViewType]);
  return (
    <div className="container">
      <header
        className="main-header detail-header"
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative' }}
      >
        {settingViewType !== ViewModel.SettingViewType.MAIN && (
          <a
            style={{ cursor: 'pointer', position: 'absolute', left: '16px' }}
            className="back-area"
            onClick={handleChangeSettingViewType}
          >
            <img src={BACK_ICON_PATH} alt="back-icon" />
          </a>
        )}
        <div className="sub-title-container" >
          <img src={TOKEN_SYMBOL_ICON_PATH} alt="GDF 로고" className="main-logo" />
          <span className="sub-title-text heading-4 font-bold">{title}</span>
        </div>
      </header>
    </div>
  );
};

export default SettingViewHeader;
